<template>
  <a-modal
    :visible="visible"
    wrap-class-name="dialog"
    :title="config.title"
    :width="config.width"
    :ok-text="config.confirmText"
    :cancel-text="config.cancelText"
    :mask-closable="false"
    @ok="submit"
    @cancel="close()"
  >
    <div class="cont">
      <a-form :model="formState">
        <a-form-item label="站长工具账号：">
          <a-select
            showSearch
            v-model:value="formState.account_id"
            style="width: 167px;"
            placeholder="请选择"
            :filterOption="filterOption"
          >
            <a-select-option
              v-for="(item, index) in listData"
              :value="item.id"
              :key="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import API from "../api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      visible: false,
      config: {
        title: "关联站长工具账号",
        width: "460px",
        confirmText: "去关联",
        cancelText: "取消",
      },
      formState: {
        account_id: "",
        ids: [],
      },
      listData: [],
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        let THAT = this;
        THAT.listData = newVal;
        if (newVal.length > 0) {
          THAT.config.confirmText = "下一步";
        } else {
          THAT.config.confirmText = "去关联";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    filterOption (value, option) {
      return option.key.toLowerCase().indexOf(value.toLowerCase()) >= 0;
    },
    open(data) {
      this.visible = true;
      this.formState.ids = data;
    },
    getList() {
      let THAT = this;
      API.customer.GET_GOOGLE_SEARCH_CONSOLE().then((res) => {
        if (res.data.code == 200) {
          THAT.listData = res.data.data;
          if (res.data.data.length > 0) {
            THAT.config.confirmText = "下一步";
          } else {
            THAT.config.confirmText = "去关联";
          }
        }
      });
    },
    submit() {
      let THAT = this;
      if (THAT.listData.length == 0) {
        this.$router.push({ path: "/CustomerManagement/Sitmap" });
      } else {
        API.customer.BINDING_ACCOUNT({ ...THAT.formState }).then((res) => {
          if (res.data.code == 200) {
            THAT.close();
            THAT.$message.success(res.data.msg);
            THAT.$emit("success", res.data.data.ids);
          }
        });
      }
    },
    close() {
      this.visible = false;
      this.formState.account_id = '';
      this.formState.ids = [];
    },
  },
};
</script>
<style scoped>
.ant-form-item {
  display: flex;
}
</style>
